import '../../../../1_templates_new/elements/js/product-view';
import '../../../../1_templates_new/elements/js/btn-one-click.js'; 

$(document).ready(() => {
    $('.info_1').find('.guide').remove();
})